<script setup lang="ts">
import { Form, Head, Link } from "@inertiajs/vue3";

import AuthCardShell from "@/components/auth-card-shell.vue";
import { Button } from "@/components/ui/button/index";
import {
  newIdentityPasswordResetPath,
  newSessionsPasswordlessPath,
  signInPath,
  signUpPath,
} from "@/routes";

defineOptions({ inheritAttrs: false });
</script>

<template>
  <Head title="Iniciar sesión" />

  <AuthCardShell
    title="Iniciar sesión"
    description="Ingresá tus credenciales para continuar."
  >
    <Form
      :action="signInPath()"
      method="post"
      disable-while-processing
      class="inert:pointer-events-none inert:opacity-80"
      #default="{ errors, processing }"
    >
      <div class="space-y-4">
        <div class="space-y-1.5">
          <label for="email" class="text-sm font-medium">Correo electrónico</label>
          <input
            id="email"
            name="email"
            type="email"
            required
            autocomplete="email"
            inputmode="email"
            placeholder="correo@ejemplo.com"
            class="input-field"
          />
          <p v-if="errors.email" class="text-sm text-destructive">
            {{ errors.email }}
          </p>
        </div>

        <div class="space-y-1.5">
          <div class="flex items-center justify-between gap-2">
            <label for="password" class="text-sm font-medium">Contraseña</label>
            <Link
              :href="newIdentityPasswordResetPath()"
              class="text-xs text-muted-foreground underline-offset-4 hover:underline"
            >
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
          <input
            id="password"
            name="password"
            type="password"
            required
            autocomplete="current-password"
            placeholder="Contraseña"
            class="input-field"
          />
          <p v-if="errors.password" class="text-sm text-destructive">
            {{ errors.password }}
          </p>
        </div>

        <Button type="submit" :disabled="processing" class="h-11 w-full text-base sm:h-10 sm:text-sm">
          {{ processing ? "Iniciando sesión..." : "Iniciar sesión" }}
        </Button>

        <Link
          :href="newSessionsPasswordlessPath()"
          class="inline-flex h-11 w-full items-center justify-center rounded-md border text-sm font-medium transition-colors hover:bg-muted"
        >
          Enviarme un enlace mágico
        </Link>
      </div>
    </Form>

    <p class="mt-6 text-center text-sm text-muted-foreground">
      ¿No tenés una cuenta?
      <Link
        :href="signUpPath()"
        class="font-medium text-foreground underline-offset-4 hover:underline"
      >Crear cuenta</Link>
    </p>
  </AuthCardShell>
</template>
